import React, {useState} from 'react';
import {Button, Form, InputGroup} from "react-bootstrap";
import {cancelSubscription} from "../../../services/manage";
import {fetchBillingLink} from "./Details";

const OPTIONS = [
  'I was working on a one-off project and only needed tiiny host for a month',
  'Tiiny Host lacked a feature I was looking for',
  'There were technical issues / I wasn\'t able to link a custom domain',
  'It was too expensive for me',
  'Something else'
]

const Cancel = ({ stripeCustomer, cancelUrl, onHide }) => {
  const [value, setValue] = useState();
  const [otherText, setOtherText] = useState();

  const onSubmit = () => {
    cancelSubscription({ value, otherText })
      .then(() => {
        if (stripeCustomer) {
          fetchBillingLink(false)
        } else {
          window.open(cancelUrl, '_blank');
        }
        onHide()
      })
      .catch(e => console.error(e));
  }

  return <div>
    <h4 className="color-purple">Cancel your subscription</h4>
    <div className="mb-3 grey">Please tell us why you would like to cancel your subscription:</div>
    <Form>
      <div className="mb-3">
        <Form.Check
          id="A"
          label={OPTIONS[0]}
          name="group1"
          type="radio"
          onClick={() => setValue('A')}
        />
        <Form.Check
          id="B"
          className="mt-2"
          label={OPTIONS[1]}
          name="group1"
          type="radio"
          onClick={() => setValue('B')}
        />
        <Form.Check
          id="C"
          className="mt-2"
          label={OPTIONS[2]}
          name="group1"
          type="radio"
          onClick={() => setValue('C')}
        />
        <Form.Check
          id="D"
          className="mt-2"
          label={OPTIONS[3]}
          name="group1"
          type="radio"
          onClick={() => setValue('D')}
        />
        <Form.Check
          id="E"
          className="mt-2"
          label={OPTIONS[4]}
          name="group1"
          type="radio"
          onClick={() => setValue('E')}
        />
        {['B', 'C', 'E'].includes(value) && <InputGroup className="input-group">
          <Form.Control
            onChange={(t) => setOtherText(t?.target?.value)}
            placeholder="Please explain in detail..."
            autoFocus={true}
            type="text"
          />
        </InputGroup>}
      </div>
      <Button
        disabled={!((value && !['B', 'C', 'E'].includes(value)) || (['B', 'C', 'E'].includes(value) && otherText?.length > 5))}
        className="float-right"
        onClick={onSubmit}
        variant="purple"
      >
        Continue
      </Button>
    </Form>
  </div>
}

export default Cancel